









import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class TooltipMeta extends Vue {
    @Prop() content!: string
    @Prop() color?: string

    get fillColor(): string {
        return this.color ? this.color : '#2196f3'
    }
}
